import { AdminOrder } from '../services/orders/orders.service';

export function orderDeliveryMapUrl(order: AdminOrder | null): string | null {
  if (!order) return null;
  const address = order.delivery?.address ?? order.customer?.delivery_address ?? {};
  const latValue = order.delivery?.lat ?? address['lat'] ?? address['latitude'];
  const lngValue = order.delivery?.lng ?? address['lng'] ?? address['longitude'];
  const lat = Number(latValue), lng = Number(lngValue);
  if (latValue != null && lngValue != null && latValue !== '' && lngValue !== '' &&
      Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180 && (lat !== 0 || lng !== 0)) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${lat},${lng}`)}`;
  }
  const text = order.delivery_address?.trim();
  return text && order.address_status !== 'Invalid' && !text.includes('Missing address')
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(text)}` : null;
}
